module.exports = __webpack_public_path__ + "static/media/bg.93c526b0.jpeg";